<div class="title">Fog of War</div>
<div class="option">
    <span>Background</span>
    <app-colorpicker [(color)]="color" [alpha]="null" (colorChange)="update()"></app-colorpicker>
</div>
